import { render, staticRenderFns } from "./EditSelectBubble.vue?vue&type=template&id=37c6bbb0&scoped=true&"
import script from "./EditSelectBubble.vue?vue&type=script&lang=js&"
export * from "./EditSelectBubble.vue?vue&type=script&lang=js&"
import style0 from "./EditSelectBubble.vue?vue&type=style&index=0&id=37c6bbb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c6bbb0",
  null
  
)

export default component.exports